import { CompanyTitledPage } from "../../TitledPage";
import DateInput from "../../../components/DateInput";
import { Button, Checkbox, Grid, Tab, Tabs } from "@mui/material";
import useSimpleOrderEntry from "./hooks/useSimpleOrderEntry";
import { useOrderFormKeyHandler } from "./hooks/useOrderFormKeyHandler";
import CustomerSelect from "./component/selects/CustomerSelect";
import OrderTable from "./component/OrderTable";
import OrderTableRow from "./component/OrderTableRow";
import OrderTableHeaderRow from "./component/OrderTableHeaderRow";
import OrderTablePaging from "./component/OrderTablePaging";
import ShopSelect from "./component/selects/ShopSelect";
import AddProductDialog from "./component/AddProductDialog";
import AddProductMasterDialog from "./component/AddProductMasterDialog";
import AddProductDetailMasterDialog from "./component/AddProductDetailMasterDialog";
import ErrorMessageBox from "../../../components/ErrorMessageBox";

// 発注表タブの内容
function PriceTab({tabPos, onChangeTab}) {

  return (
    <Tabs value={tabPos} onChange={(_e, v) => onChangeTab(v)}>
      <Tab label="蔬菜" value={1} />
      <Tab label="果物" value={2} />
      <Tab label="スポット" value={3} />
    </Tabs>
  );
}

function SimpleOrderEntryPage() {  
  const simpleOrderEntry = useSimpleOrderEntry();

  const keyHandler = useOrderFormKeyHandler(
    simpleOrderEntry.page,
    simpleOrderEntry.maxPage,
    simpleOrderEntry.changePage
  );

  const orderTableRows= simpleOrderEntry.pageOrdersForm.orders
    .map((order, rowIndex) => (
      <OrderTableRow
        order={order} 
        orderControl={simpleOrderEntry.ordersForm.orderControl(order.orderIndex)}
        keyHandler={keyHandler(rowIndex)}
        isShippingDateUndecided={simpleOrderEntry.isShippingDateUndecided}
        key={`order-${order.orderIndex}`}
      />
    ));

  const orderTableHeaderRow = (
    <OrderTableHeaderRow
      isShippingDateUndecided={simpleOrderEntry.isShippingDateUndecided}
    />
  );

  const handleChangeShippingDateUndecided = (e) => {
    simpleOrderEntry.changeShippingDateUndecided(e.target.checked);
  }

  const handleClickSubmit = (_e) => {
    simpleOrderEntry.submitOrders();
  }

  const handleChangeCustomerSelect = (customerId) => {
    simpleOrderEntry.changeCustomerSelect(customerId);
  }

  const handleChangeShopSelect = (shopId) => {
    simpleOrderEntry.changeShopSelect(shopId);
  }

  const handleChangePriceUndecided = (e) => {
    simpleOrderEntry.changePriceUndecided(e.target.checked);
  }

  const handleChangeTabPosition = (tabPos) => {
    simpleOrderEntry.changeTab(tabPos);
  }

  const handleClickAddProduct = (_e) => {
    simpleOrderEntry.addProduct();
  }

  const disabledAddProduct = !simpleOrderEntry.selectedShopId;

  const disabledSubmit
    = !simpleOrderEntry.selectedShopId
        || simpleOrderEntry.errorMessages.length > 0

  return (
    <CompanyTitledPage title="単注文入力">
      <Grid container spacing={2}>
        <Grid item>
          出荷日:
          <DateInput
            value={simpleOrderEntry.shippingDate}
            setValue={simpleOrderEntry.changeShippingDate}
            disabled={simpleOrderEntry.isShippingDateUndecided}
            sx={{ml: 1}}
          />          
        </Grid>
        <Grid item mr={4}>
          <Checkbox
            checked={simpleOrderEntry.isShippingDateUndecided}
            onChange={handleChangeShippingDateUndecided}
          />
          出荷日未定
        </Grid>
        <Grid item>
          取引先: 
          <CustomerSelect
            customers={simpleOrderEntry.customers}
            selectedCustomerId={simpleOrderEntry.selectedCustomerId}
            onChangeCustomer={handleChangeCustomerSelect}
            sx={{ml: 1, width: "300px"}}
          />
        </Grid>
        <Grid item>
          店舗: 
          <ShopSelect
            shops={simpleOrderEntry.shops}
            customerId={simpleOrderEntry.selectedCustomerId}
            selectedShopId={simpleOrderEntry.selectedShopId}
            onChangeShop={handleChangeShopSelect}
            disabled={!simpleOrderEntry.selectedCustomerId}
            sx={{ml: 1, width: "200px"}}
          />
        </Grid>
        <Grid item xs>
          <Checkbox
            checked={simpleOrderEntry.isPriceUndecided}
            onClick={handleChangePriceUndecided}
          />
          価格未定で絞る
        </Grid>    
      </Grid>

      <ErrorMessageBox
        messages={simpleOrderEntry.errorMessages}      
      />
      
      <Grid container spacing={2}  mb={2}>
        <Grid item xs>
          <PriceTab
            tabPos={simpleOrderEntry.tabPos}
            onChangeTab={handleChangeTabPosition}
          />
        </Grid>
        <Grid item>
          <Button
            variant="outlined"
            color="error"
            onClick={handleClickAddProduct}
            disabled={disabledAddProduct}
          >
            商品追加
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            onClick={handleClickSubmit}
            disabled={disabledSubmit}
          >
            確定
          </Button>
        </Grid>
      </Grid>

      <OrderTable
        headerRow={orderTableHeaderRow}
        rows={orderTableRows}
      />

      <OrderTablePaging
        page={simpleOrderEntry.page}
        changePage={simpleOrderEntry.changePage}
        maxPage={simpleOrderEntry.maxPage}
      />

      <AddProductDialog
        {...simpleOrderEntry.addProductDialogs.addProductDialog}
        addingProduct={simpleOrderEntry.addProductDialogs.addingProduct}
        addedProducts={simpleOrderEntry.ordersForm.orders}
        tabPosition={simpleOrderEntry.tabPos}
      />
      
      <AddProductMasterDialog
        {...simpleOrderEntry.addProductDialogs.addProductMasterDialog}
        addingProduct={simpleOrderEntry.addProductDialogs.addingProduct}
      />

      <AddProductDetailMasterDialog
        {...simpleOrderEntry.addProductDialogs.addProductDetailMasterDialog}
        addingProduct={simpleOrderEntry.addProductDialogs.addingProduct}
      />
      
    </CompanyTitledPage>
  );
}

export default SimpleOrderEntryPage;
